import React, { useState, useEffect, Component } from 'react';
import { RiRefreshLine } from "react-icons/ri";
import { FaSave } from "react-icons/fa";
import "./table.css"
import { Modal, Button, Form, Row, Col, ProgressBar } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import ApiService from '../../../EpicGame/services/apiService';
import { IoMdAdd } from "react-icons/io";
import { toast } from 'react-toastify';
import moment from 'moment';
import Select from 'react-select';
import { ClipLoader } from 'react-spinners';

const PanelHome = () => {

    const [formData, setFormData] = useState({
        userName: "",
        phoneNumber: '',
        fromDate: '',
        toDate: '',
    });
    const [AddData, setAddData] = useState({
        username: "",
        email: "",
        mobileNumber: "",
        balance: 0,
        invitationCode: "",
        reputation: "",
        parentUser: "",
        invitationCode: "",
        status: true,
        memberLevel: 0,
        frozenAmount: 0,
        robSingle: "",
        registrationTime: new Date().toISOString(),
        matchingRange: "",
        paymentPassword: "",
        firstName: "",
        lastName: "",
        widthDrawPassword: "",
        userPassword: "",
        credibility: "",
        withdrawMinimumAmount: 0,
        withdrawMaximumAmount: 0,
        withdrawNeedtoCompleteOrderst: "",
        whethertoAllowroborder: true,
        whethertoallowwithdraw: true,
        numberofdraws: "",
        winningAmount: 0
    });
    const [openId, setOpenId] = useState(null);
    const [walletUser, setWalletUser] = useState(null);
    const [walletModal, setWalletModal] = useState(false);
    const [editUser, setEditUser] = useState(false);
    const [resetPopup, setresetPopup] = useState(false);
    const [editUserDetails, setEditUserDetails] = useState(null);
    const [ResetModal, setResetModal] = useState(false);
    const [ResetModalData, setResetModalData] = useState(null);
    const [addUser, setAddUser] = useState(null);
    const [loader, setLoader] = useState(null);
    const apiService = new ApiService();
    let navigate = useNavigate();
    const [rowData, setRowData] = useState([]);
    const [level, setLevel] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [crypto, setCrypto] = useState();
    const [network, setNetwork] = useState();
    const recordsPerPage = 30;
    const [passwordForm, setPasswordForm] = useState({
        password: '',
        confirmPassword: ''
    });
    useEffect(() => {
        fetchuser();
    }, []);

    const fetchuser = async () => {
        try {
            const params = new URLSearchParams();
            params.append('username', formData?.userName || "");
            params.append('phoneNumber', formData?.phoneNumber || "");
            params.append('start', formData?.fromDate || "");
            params.append('end', formData?.toDate || "");
            const response = await apiService.getApiParamater('GET_GAME_USER', `?${params.toString()}`);
            // const response = await apiService.get('GET_GAME_USER');
            const levelResponse = await apiService.get('GET_USER_LEVEL');
            setRowData(response?.data?.reverse());
            setLevel(levelResponse?.data);

        } catch (error) {
            console.error("Error fetching Currency data:", error);
        }
    };
    const handleToggle = (id) => {
        setOpenId(openId === id ? null : id);
    };
    const handleReset = () => {
        setFormData({
            userName: "",
            phoneNumber: "",
            fromDate: '',
            toDate: '',
        });
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'fromDate' || name === 'toDate') {
            const dateParts = e.target.value.split("-");
            if (dateParts[0].length > 4) {
                return;
            }
        }
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    const handleWalletClick = async (user) => {
        try {
            const params = new URLSearchParams();
            // params.append('id', user?.id);
            params.append('userId', user?.id);
            const response = await apiService.getApiParamater('GET_WALLET_DETAILS', `?${params.toString()}`);
            debugger
            setWalletUser(response?.data[0]);
            setNetwork(response?.data[0]?.paymentNetwork)
            setCrypto(response?.data[0]?.cryptocurrency)
        } catch (error) {
            console.error("Error fetching Currency data:", error);
        }
        setWalletModal(true);
    };
    const handleResetUser = async (user) => {
        try {
            setResetModalData(user);
            setResetModal(true)
        } catch (error) {
            console.error("Error data:", error);
        }
    };
    const handleEditClick = (user) => {
        setEditUser(true);
        setEditUserDetails(user)
    };
    const handleResetPassword = (user) => {
        setresetPopup(true);
        setEditUserDetails(user)
    };
    const handleEditCloseModal = () => {
        setEditUser(false);
        setEditUserDetails(null);
    };
    const handleEditChange = (e) => {
        if (e.label) {
            setEditUserDetails(prev => ({
                ...prev,
                memberLevel: e?.value?.id
            }));
        } else {
            const { name, value, type, checked } = e.target;
            const newValue = type === 'checkbox' ? checked : value;
            setEditUserDetails(prev => ({
                ...prev,
                [name]: newValue
            }));
        }
    };
    const handleWalletChange = (e) => {
        const { name, value, type, checked } = e.target;
        const newValue = type === 'checkbox' ? checked : value;
        setWalletUser(prev => ({
            ...prev,
            [name]: newValue
        }));
    };
    const handlePaswordChange = (e) => {
        const { name, value, type, checked } = e.target;
        const newValue = type === 'checkbox' ? checked : value;
        setPasswordForm(prev => ({
            ...prev,
            [name]: newValue
        }));
    };
    const handleSaveEditUser = async () => {
        // const updatedRowData = rowData.map(item =>
        //     item.id === editUserDetails.id ? editUserDetails : item
        // );
        // setRowData(updatedRowData);
        try {
            setLoader(true);
            let body = {
                id: editUserDetails?.id,
                username: editUserDetails?.username,
                email: editUserDetails?.email,
                mobileNumber: editUserDetails?.mobileNumber,
                balance: parseInt(editUserDetails?.balance),
                parentId: parseInt(editUserDetails?.parentId),
                reputation: parseInt(editUserDetails?.reputation),
                parentUser: editUserDetails?.parentUser,
                invitationCode: editUserDetails?.invitationCode,
                status: 1,
                memberLevel: parseInt(editUserDetails?.memberLevel),
                frozenAmount: parseInt(editUserDetails?.frozenAmount),
                robSingle: true,
                matchingRange: parseInt(editUserDetails?.matchingRange),
                paymentPassword: editUserDetails?.paymentPassword,
                firstName: editUserDetails?.firstName,
                lastName: editUserDetails?.lastName,
                widthDrawPassword: editUserDetails?.widthDrawPassword,
                credibility: parseInt(editUserDetails?.credibility),
                withdrawMinimumAmount: parseInt(editUserDetails?.withdrawMinimumAmount),
                withdrawMaximumAmount: parseInt(editUserDetails?.withdrawMaximumAmount),
                withdrawNeedtoCompleteOrderst: parseInt(editUserDetails?.withdrawNeedtoCompleteOrderst),
                whethertoAllowroborder: true,
                whethertoallowwithdraw: true,
                numberofdraws: parseInt(editUserDetails?.numberofdraws),
                winningAmount: parseInt(editUserDetails?.winningAmount)
            }
            debugger
            const response = await apiService.put('UPDATE_GAME_USER', body);
            if (response?.status === 200 || response?.status === 201) {
                fetchuser(); // Refresh user list
                handleEditCloseModal(); // Close modal
            }
        } catch (error) {
            console.error("Error Updating User:", error);
        } finally {
            setLoader(false);
        }
    };
    const handleContinuousClick = (user) => {
        navigate("/Product/Listing", { state: user });
    };
    const handleRegister = async () => {
        setLoader(true)
        if (!AddData?.mobileNumber) {
            setLoader(false)
            toast.warning("Enter Mobile Number")
            return;
        } else if (!AddData?.userPassword) {
            setLoader(false)
            toast?.warning("Enter Password ")
            return;
        } else if (!AddData?.username) {
            setLoader(false)
            toast?.warning("Enter UserName ")
            return;
        }
        const currentDatetimeUTC = new Date().toISOString();
        let body = {
            username: AddData?.username || "",
            email: AddData?.email || "",
            mobileNumber: AddData?.mobileNumber,
            invitationCode: AddData?.invitationCode,
            status: true,
            registrationTime: currentDatetimeUTC,
            paymentPassword: AddData?.paymentPassword || "",
            firstName: AddData?.username || "",
            lastName: AddData?.username || "",
            widthDrawPassword: AddData?.widthDrawPassword || "",
            userPassword: AddData?.userPassword,
        }
        try {
            const response = await apiService.post('CREATE_GAME_USER', body);
            if (response?.status === 200) {
                fetchuser()
                handleAddCloseModal()
                setFormData({
                    username: "",
                    email: "",
                    mobileNumber: "",
                    balance: 0,
                    parentId: "",
                    reputation: "",
                    parentUser: "",
                    invitationCode: "",
                    status: true,
                    memberLevel: 0,
                    frozenAmount: 0,
                    robSingle: "",
                    registrationTime: new Date().toISOString(),
                    matchingRange: "",
                    paymentPassword: "",
                    firstName: "",
                    lastName: "",
                    widthDrawPassword: "",
                    userPassword: "",
                    credibility: "",
                    withdrawMinimumAmount: 0,
                    withdrawMaximumAmount: 0,
                    withdrawNeedtoCompleteOrderst: "",
                    whethertoAllowroborder: true,
                    whethertoallowwithdraw: true,
                    numberofdraws: "",
                    winningAmount: ""
                });
                setLoader(false)
            }
            setLoader(false)
        } catch (error) {
            setLoader(false)
            console.error("Error Creating User:", error);
        }
    };
    const handleResetPasswordsave = async () => {
        setLoader(true)
        if (!passwordForm?.password) {
            setLoader(false)
            toast.warning("Enter Password")
            return;
        } else if (passwordForm?.password != passwordForm?.confirmPassword) {
            setLoader(false)
            toast.warning("Both password must be same")
            return;
        }

        const payload = {
            userId: editUserDetails?.id,
            newPassword: passwordForm?.password
        };
        debugger
        try {
            const response = await apiService.post('RESET_PASSWORD', payload);
            debugger
            if (response?.status === 200) {
                fetchuser()
                handleClosePasswordModal()
                setEditUserDetails(null)
                setPasswordForm({
                    password: '', // default
                    confirmPassword: ''
                });
                setLoader(false)
            }
            setLoader(false)
        } catch (error) {
            setLoader(false)
            console.error("Error reset:", error);
        }
    };
    const handleLogin = async () => {
        setLoader(true)
        const apiService = new ApiService();
        let body = {
            userId: walletUser?.userId,
            name: walletUser?.name,
            receiptAddress: walletUser?.receiptAddress,
            cryptocurrency: crypto,
            paymentNetwork: network,
            phoneNumber: walletUser?.phoneNumber,
        }
        try {
            const response = await apiService.post('CREATE_WALLET', body);
            if (response?.status === 200) {
                toast.success("Wallet saved Sucessfully")
                setLoader(false)
            } else {
                toast.error(response?.data.message)
                setLoader(false)
                fetchuser(); // Refresh user list
                setWalletModal(false);
            }

        } catch (error) {
            console.error("Error Save Wallet:", error);
            toast.error(error?.response?.data.message)
            setLoader(false)
        }
    };
    const handleDebitClick = (user) => {
        navigate("/Add_Debit", { state: user });
    };
    const handleResetData = async () => {
        try {
            debugger
            // const response = await apiService.post('RESET_USER', ResetModalData);

            const gameParams = new URLSearchParams();
            gameParams.append('userId', ResetModalData);
            const response = await apiService.postpath('RESET_USER', `?userId=${ResetModalData}`);

            if (response?.data?.data === "User reset successfully.") {
                fetchuser()
                setResetModal(false)
                setResetModalData(null)
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error(error?.response?.data.message)
        }
    };
    const handleCloseModal = () => setWalletModal(null);
    const handleClosePasswordModal = () => setresetPopup(null);
    const handleAddClick = () => setAddUser(true);
    const handleAddCloseModal = () => setAddUser(null);
    const handleResetModal = () => setResetModal(null);

    const handleUpdateStatus = async (details) => {

        try {
            setLoader(true);
            let body = {
                id: details?.id,
                username: details?.username,
                email: details?.email,
                mobileNumber: details?.mobileNumber,
                balance: parseInt(details?.balance),
                parentId: parseInt(details?.parentId),
                reputation: parseInt(details?.reputation),
                parentUser: details?.parentUser,
                invitationCode: details?.invitationCode,
                status: details?.status === true ? 1 : 0,
                memberLevel: parseInt(details?.memberLevel),
                frozenAmount: parseInt(details?.frozenAmount),
                robSingle: true,
                matchingRange: parseInt(details?.matchingRange),
                paymentPassword: details?.paymentPassword,
                firstName: details?.firstName,
                lastName: details?.lastName,
                widthDrawPassword: details?.widthDrawPassword,
                credibility: parseInt(details?.credibility),
                withdrawMinimumAmount: parseInt(details?.withdrawMinimumAmount),
                withdrawMaximumAmount: parseInt(details?.withdrawMaximumAmount),
                withdrawNeedtoCompleteOrderst: parseInt(details?.withdrawNeedtoCompleteOrderst),
                whethertoAllowroborder: true,
                whethertoallowwithdraw: true,
                numberofdraws: parseInt(details?.numberofdraws),
                winningAmount: parseInt(details?.winningAmount)
            }
            debugger
            const response = await apiService.put('UPDATE_GAME_USER', body);
            if (response?.status === 200 || response?.status === 201) {
                toast?.success(`User ${details?.status === true ? "Active" : "InActive"} Successfully`)
                fetchuser(); // Refresh user list
            }
        } catch (error) {
            console.error("Error Update Status:", error);
            toast.error(error?.response?.data.message)
        }
    };

    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;

    const currentRecords = rowData?.slice(indexOfFirstRecord, indexOfLastRecord);

    const totalPages = Math.ceil(rowData.length / recordsPerPage);

    return (
        <div className='px-4 pb-5'>
            <div className='border-box2 p-4'>
                <div className='row d-flex justify-content-between pb-3'>
                    <div className='col'>
                        <div className='d-flex gap-2'>
                            <label htmlFor="validationCustom01" className="form-label w-50">UserName</label>
                            <label htmlFor="validationCustom01" className="form-label w-50">Phone Number</label>
                        </div>
                        <div className='d-flex gap-2'>
                            <input type='text' className="form-control w-50" name='userName' value={formData?.userName} placeholder='Enter UserName' onChange={handleInputChange} />
                            <input type='number' min={0} className="form-control w-50" name='phoneNumber' placeholder='Enter Phone Number' value={formData?.phoneNumber} onChange={handleInputChange} />
                        </div>
                    </div>
                    <div className='col'>
                        <div className='d-flex gap-2'>
                            <label htmlFor="validationCustom01" className="form-label w-50">From Date</label>
                            <label htmlFor="validationCustom01" className="form-label w-50">To Date</label>
                        </div>
                        <div className='d-flex gap-2'>
                            <input type='datetime-local' className="form-control w-50" value={formData?.fromDate} onChange={handleInputChange} name='fromDate' />
                            <input type='datetime-local' className="form-control w-50" value={formData?.toDate} onChange={handleInputChange} name='toDate' />
                        </div>
                    </div>
                    <div className='col d-flex gap-3 mt-4'>
                        <button className='btn btn-primary d-flex center gap-3' type="submit" onClick={fetchuser}><FaSave /><div>Search</div></button>
                        <button className='btn btn-primary d-flex center gap-3' onClick={handleReset} ><RiRefreshLine /><div>Reset</div></button>
                        <button className='btn btn-secondary d-flex center gap-3' type="submit" onClick={handleAddClick}><IoMdAdd /><div>Add User</div></button>
                    </div>
                </div>
            </div>
            <div className="table-container mx-4">
                <table className="custom-table">
                    <thead>
                        <tr>
                            <th>operation</th>
                            <th>ID</th>
                            <th>username</th>
                            <th>parent ID</th>
                            <th>mobile number</th>
                            <th>Status</th>
                            <th>balance</th>
                            <th>daily available orders</th>
                            <th>today's orders</th>
                            <th>today's commission</th>
                            {/* <th>reputation</th> */}
                            <th>Parent User</th>
                            <th>Invitation COde</th>
                            <th>Member Level</th>
                            {/* <th>Frozen Amount</th> */}
                            {/* <th>Rob Signal</th> */}
                            <th>Registration Time</th>
                            <th>Last Login Time</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentRecords?.map((row, index) => (
                            <tr key={row.id}>

                                <td className="actions-cell fixed">
                                    <div className="action-row d-flex">
                                        <div><button className="btn orange" onClick={() => handleContinuousClick(row)}>set Negative</button></div>
                                        <div><button className="btn red" onClick={() => handleDebitClick(row)}>Add debit</button></div>
                                        <button className="btn blue full-width" onClick={() => handleResetUser(row.id)}>Reset</button>
                                        <div className="btndropdown-container">
                                            <button className="btn bordered" onClick={() => handleToggle(row.id)}>
                                                More Actions
                                            </button>
                                            {openId === row.id && (
                                                <div className="btndropdown">
                                                    <div className="btndropdown-item" onClick={() => handleWalletClick(row)}>Wallet Information</div>
                                                    <div className="btndropdown-item" onClick={() => handleEditClick(row)}>Edit</div>
                                                    <div className="btndropdown-item" onClick={() => handleResetPassword(row)}>Reset Password</div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </td>
                                <td>{index + 1}</td>
                                <td>{row.username}</td>
                                <td>{row.parentId}</td>
                                <td>{row.mobileNumber}</td>
                                <td>
                                    <label className="switch">
                                        <input
                                            type="checkbox"
                                            checked={row.status}
                                            onChange={() => handleUpdateStatus({ ...row, status: !row.status })}
                                        />
                                        <span className="slider round"></span>
                                    </label>
                                </td>
                                <td>{row.balance?.toFixed(2)}</td>
                                <td>{row.totalGames}</td>
                                <td>{row.playedGames}</td>
                                <td>{row.winningAmount}</td>
                                {/* <td>{row.reputation}</td> */}
                                <td>{row.parentUser}</td>
                                <td>{row.invitationCode}</td>
                                {/* Replace status with toggle switch button to active or inactive */}
                                {/* <td>{row.status === true ? "Active" : "In-Active"}</td> */}
                                <td>{row.memberLevel}</td>
                                {/* <td>{row.frozenAmount}</td> */}
                                {/* <td>{row.robSingle}</td> */}
                                <td>{moment(row?.registrationTime).format("MMM Do YY")}</td>
                                <td>{moment(row?.lastLogin).format("LLL")}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="pagination-container">
                <button
                    className="pagination-btn"
                    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                    disabled={currentPage === 1}
                >
                    ❮ Prev
                </button>

                {[...Array(totalPages)].map((_, i) => (
                    <button
                        key={i}
                        className={`pagination-number ${currentPage === i + 1 ? "active" : ""}`}
                        onClick={() => setCurrentPage(i + 1)}
                    >
                        {i + 1}
                    </button>
                ))}

                <button
                    className="pagination-btn"
                    onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                    disabled={currentPage === totalPages}
                >
                    Next ❯
                </button>
            </div>
            {/* Add User Info Modal */}
            <Modal show={!!addUser} onHide={handleAddCloseModal} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Add User</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Username</Form.Label>
                            <Form.Control
                                value={AddData.username}
                                onChange={(e) => setAddData({ ...AddData, username: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                                value={AddData.email}
                                onChange={(e) => setAddData({ ...AddData, email: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Phone Number</Form.Label>
                            <Form.Control
                                value={AddData.mobileNumber}
                                onChange={(e) => setAddData({ ...AddData, mobileNumber: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Balance</Form.Label>
                            <Form.Control
                                type="number"
                                value={AddData.balance}
                                onChange={(e) => setAddData({ ...AddData, balance: parseFloat(e.target.value) })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Parent ID</Form.Label>
                            <Form.Control
                                value={AddData.invitationCode}
                                onChange={(e) => setAddData({ ...AddData, invitationCode: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Credibility</Form.Label>
                            <Form.Control
                                value={AddData.credibility}
                                onChange={(e) => setAddData({ ...AddData, credibility: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Frozen Amount</Form.Label>
                            <Form.Control
                                type="number"
                                value={AddData.frozenAmount}
                                onChange={(e) => setAddData({ ...AddData, frozenAmount: parseFloat(e.target.value) })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Password</Form.Label>
                            <Form.Control
                                value={AddData.userPassword}
                                onChange={(e) => setAddData({ ...AddData, userPassword: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Payment Password</Form.Label>
                            <Form.Control
                                value={AddData.paymentPassword}
                                onChange={(e) => setAddData({ ...AddData, paymentPassword: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Withdraw Minimum Amount</Form.Label>
                            <Form.Control
                                type="number"
                                value={AddData.withdrawMinimumAmount}
                                onChange={(e) => setAddData({ ...AddData, withdrawMinimumAmount: parseFloat(e.target.value) })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Withdraw Maximum Amount</Form.Label>
                            <Form.Control
                                type="number"
                                value={AddData.withdrawMaximumAmount}
                                onChange={(e) => setAddData({ ...AddData, withdrawMaximumAmount: parseFloat(e.target.value) })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Withdraw Need to Complete Orders</Form.Label>
                            <Form.Control
                                value={AddData.withdrawNeedtoCompleteOrderst}
                                onChange={(e) => setAddData({ ...AddData, withdrawNeedtoCompleteOrderst: e.target.value })}
                            />
                        </Form.Group>
                        <Col>
                            <Form.Check
                                id="rob-offer-switch"
                                label="Whether to allow rob order"
                                type="switch"
                                checked={AddData.whethertoAllowroborder}
                                onChange={(e) => setAddData({ ...AddData, whethertoAllowroborder: e.target.checked })}
                            />
                        </Col>
                        <Col>
                            <Form.Check
                                id="withdraw-switch"
                                label="Whether to allow withdraw"
                                type="switch"
                                checked={AddData.whethertoallowwithdraw}
                                onChange={(e) => setAddData({ ...AddData, whethertoallowwithdraw: e.target.checked })}
                            />
                        </Col>
                        <Form.Group className="mb-3">
                            <Form.Label>Number of Draws</Form.Label>
                            <Form.Control
                                value={AddData.numberofdraws}
                                onChange={(e) => setAddData({ ...AddData, numberofdraws: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Winning Amount</Form.Label>
                            <Form.Control
                                value={AddData.winningAmount}
                                onChange={(e) => setAddData({ ...AddData, winningAmount: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Completion</Form.Label>
                            <ProgressBar now={65} label="65%" />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleAddCloseModal}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={() => handleRegister(AddData)}>
                        OK
                    </Button>
                </Modal.Footer>
            </Modal>
            {/* Wallet Info Modal */}
            <Modal show={walletModal} onHide={handleCloseModal} size="md" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Wallet Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group">
                        <label>UserName</label>
                        <input type="text" className="form-control" readOnly name="name" value={walletUser?.name || ''} />

                        <label>Receipt Address</label>
                        <input type="text" className="form-control" onChange={handleWalletChange} name="receiptAddress" value={walletUser?.receiptAddress || ''} />

                        <label>Cryptocurrency</label>
                        <div className="d-flex gap-3 mb-2">
                            {['USDT', 'USDC', 'ETH', 'BTC'].map((coin) => (
                                <div key={coin} className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="cryptocurrency"
                                        value={coin}
                                        onChange={() => setCrypto(coin)}
                                        checked={crypto === coin}
                                    />
                                    <label className="form-check-label">{coin}</label>
                                </div>
                            ))}
                        </div>
                        <label>Payment Network</label>
                        <div className="d-flex gap-3 mb-2">
                            {['TRC20', 'ERC20', 'BTC'].map((net) => (
                                <div key={net} className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="paymentNetwork"
                                        onChange={() => setNetwork(net)}
                                        value={net}
                                        checked={network === net}
                                    />
                                    <label className="form-check-label">{net}</label>
                                </div>
                            ))}
                        </div>
                        <label>Phone Number</label>
                        <input type="text" className="form-control" onChange={handleWalletChange} name="phoneNumber" value={walletUser?.phoneNumber || ''} />

                        <div className='center p-3 '>
                            {loader === true ?
                                <button class="btn btn-scondary center w-100 btn-lg " type="button">
                                    <ClipLoader color='#fff' />
                                </button>
                                :
                                <button class="btn btn-primary" onClick={handleLogin}>Submit</button>
                            }
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            {/* Edit User Info Modal */}
            <Modal show={editUser} onHide={handleEditCloseModal} size="md" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Edit User</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group">
                        <label>UserName</label>
                        <input type="text" className="form-control" name="username" value={editUserDetails?.username || ''} onChange={handleEditChange} />

                        <label>Member Level</label>
                        <Select
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                    color: state.isFocused ? '#000 ' : '#000',
                                    ':hover': {
                                        backgroundColor: '#F5F5F5',
                                        color: '#000 ',
                                    },
                                }),
                            }}
                            menuPlacement="auto"
                            menuShouldScrollIntoView={false}
                            className="p-0" value={{ label: editUserDetails?.memberLevel, value: editUserDetails?.memberLevel }}
                            onChange={handleEditChange}
                            options={level?.map((sup) => ({ value: sup, label: sup?.name }))}
                        />
                        <label>Parent ID</label>
                        <input type="text" className="form-control" name="invitationCode" value={editUserDetails?.invitationCode || ''} onChange={handleEditChange} />

                        <label>Balance</label>
                        <input type="text" className="form-control" name="balance" value={editUserDetails?.balance || ''} onChange={handleEditChange} />

                        <label>Frozen Amount</label>
                        <input type="text" className="form-control" name="frozenAmount" value={editUserDetails?.frozenAmount || ''} onChange={handleEditChange} />

                        <label>Mobile Number</label>
                        <input type="text" className="form-control" name="mobileNumber" value={editUserDetails?.mobileNumber || ''} onChange={handleEditChange} />

                        <label>Reputation</label>
                        <input type="text" className="form-control" name="reputation" value={editUserDetails?.reputation || ''} onChange={handleEditChange} />

                        <label>Password</label>
                        <input type="text" className="form-control" name="password" value={editUserDetails?.password || ''} onChange={handleEditChange} />

                        <label>Payment Password</label>
                        <input type="text" className="form-control" name="paymentPassword" value={editUserDetails?.paymentPassword || ''} onChange={handleEditChange} />

                        <label>Credibility</label>
                        <input type="text" className="form-control" name="credibility" value={editUserDetails?.credibility || ''} onChange={handleEditChange} />

                        <label>Withdraw Minimum Amount</label>
                        <input type="text" className="form-control" name="withdrawMinimumAmount" value={editUserDetails?.withdrawMinimumAmount || ''} onChange={handleEditChange} />

                        <label>Withdraw Maximum Amount</label>
                        <input type="text" className="form-control" name="withdrawMaximumAmount" value={editUserDetails?.withdrawMaximumAmount || ''} onChange={handleEditChange} />

                        <label>Withdraw Need to Complete Orders</label>
                        <input type="text" className="form-control" name="withdrawNeedtoCompleteOrderst" value={editUserDetails?.withdrawNeedtoCompleteOrderst || ''} onChange={handleEditChange} />

                        <div className="form-check form-switch my-2">
                            <input className="form-check-input" type="checkbox" name="whethertoAllowroborder" checked={editUserDetails?.whethertoAllowroborder || false} onChange={handleEditChange} />
                            <label className="form-check-label">Allow Rob Order</label>
                        </div>

                        <div className="form-check form-switch mb-3">
                            <input className="form-check-input" type="checkbox" name="whethertoallowwithdraw" checked={editUserDetails?.whethertoallowwithdraw || false} onChange={handleEditChange} />
                            <label className="form-check-label">Allow Withdraw</label>
                        </div>

                        <label>Number of Draws</label>
                        <input type="text" className="form-control" name="numberofdraws" value={editUserDetails?.numberofdraws || ''} onChange={handleEditChange} />

                        <label>Winning Amount</label>
                        <input type="text" className="form-control" name="winningAmount" value={editUserDetails?.winningAmount || ''} onChange={handleEditChange} />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex gap-3'>
                        <Button variant="secondary" className="w-50" onClick={handleEditCloseModal}>
                            Cancel
                        </Button>
                        <Button variant="primary" className="w-50" onClick={handleSaveEditUser}>
                            Save
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
            {/* Reset Password Modal */}
            <Modal show={resetPopup} onHide={handleClosePasswordModal} size="md" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Reset Password</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group">
                        <label>Password</label>
                        <input type="text" className="form-control" name="password"
                            onChange={handlePaswordChange} value={passwordForm?.password || ''} />
                        <label>Confirm Password</label>
                        <input
                            type="text"
                            className="form-control"
                            name="confirmPassword"
                            value={passwordForm.confirmPassword}
                            onChange={handlePaswordChange}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex gap-3'>
                        <Button variant="secondary" className="w-50" onClick={handleClosePasswordModal}>
                            Cancel
                        </Button>
                        <Button variant="primary" className="w-50" onClick={handleResetPasswordsave}>
                            Save
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
            {/* Reset User Modal */}
            <Modal show={ResetModal} onHide={handleResetModal} size="md" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Reset User</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h5>Are you sure you want to reset User Data</h5>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex gap-3'>
                        <Button variant="secondary" className="w-50" onClick={handleResetModal}>
                            Cancel
                        </Button>
                        <Button variant="primary" className="w-50" onClick={handleResetData}>
                            Save
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </div >
    );
};
export default PanelHome;